/* eslint-disable react/require-default-props */
import React, { useState, useRef, useCallback } from 'react';
import { Popup } from '@progress/kendo-react-popup';
import ClickAwayListener from 'react-click-away-listener';
import './RelatedItems.scss';
function RelatedItems({ items }) {
    return (React.createElement("div", { className: "qmb-actions" },
        React.createElement("div", { className: "relatedItemsContainer" }, items.map((item) => (React.createElement(RelatedItem, { key: item.label, label: item.label, labelClass: item.labelClass, items: item.items }))))));
}
function RelatedItem({ label, labelClass, items }) {
    const [visible, setVisible] = useState(false);
    const anchor = useRef(null);
    if (items.length === 1) {
        return (React.createElement("ul", { role: "presentation", className: "content-actions__refs" },
            React.createElement("li", null,
                React.createElement("a", { href: items[0].path, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement("i", { className: labelClass }),
                    " ",
                    items[0].display))));
    }
    const getItemKey = useCallback((item) => `${item.display.replace(' #', '').toLowerCase()}-${item.path}`, []);
    return (React.createElement("div", { className: "content-actions__option--multi content-actions__refs", id: `content_action_${label}` },
        React.createElement("button", { type: "button", className: "qmb-control--menu content-actions__toggle", onClick: () => setVisible(true), ref: anchor }, `${items.length} ${label}`),
        React.createElement(Popup, { anchor: anchor.current, show: visible, onClose: () => setVisible(false) },
            React.createElement(ClickAwayListener, { onClickAway: () => setVisible(false) },
                React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list" },
                    React.createElement("ul", { role: "presentation", className: "content-actions__refs" }, items.map((item) => (React.createElement("li", { key: getItemKey(item), role: "presentation" },
                        React.createElement("a", { href: item.path, target: "_blank", rel: "noopener noreferrer" },
                            React.createElement("i", { className: labelClass }),
                            " ",
                            item.display))))))))));
}
export default RelatedItems;
